export const LOADING = 'Loading';